export const LABEL_TYPES = [
    {
        name: 'International',
        value: 'international',
    },
    {
        name: 'US',
        value: 'us',
    },
    {
        name: 'VN',
        value: 'vn',
    },
    {
        name: 'SG',
        value: 'sg',
    },
    {
        name: 'UK',
        value: 'uk',
    },
]

export const LABEL_STATUS = [
    {
        name: 'Tất cả',
        value: '',
    },
    {
        name: 'Printable',
        value: 'printable',
    },
    {
        name: 'Unprintable',
        value: 'unprintable',
    },
]

export const JOB_SHIPPING_CARRIER = [
    {
        name: 'Tất cả',
        value: ''
    },
    {
        name: 'Royal Mail',
        value: 'Royal Mail'
    },
    {
        name: 'Singapore Post',
        value: 'Singapore Post'
    },
    {
        name: 'Shopee',
        value: 'shopee'
    },
    {
        name: 'TimUS',
        value: 'timus'
    },
    {
        name: 'UPS',
        value: 'UPS'
    },
    {
        name: 'USPS MN',
        value: 'USPS MN'
    },
    {
        name: 'Daily Design',
        value: 'DailyDesign'
    },
    {
        name: 'LLC_manual',
        value: 'LLC_manual'
    },
    {
        name: 'DPD UK',
        value: 'DPD UK'
    },
    {
        name: 'SB CA',
        value: 'SB CA'
    },
    {
        name: 'SB AU',
        value: 'SB AU'
    },
    {
        name: 'SB-YUN',
        value: 'SB-YUN'
    },
    {
        name: 'HW_USPS',
        value: 'HW_USPS'
    },
    {
        name: 'JT_USPS',
        value: 'JT_USPS'
    },
]
